import { OrganizationConfig } from 'services/organization/type';

type GetDefaultRejectionMessageParams = {
  isEngagementOutreach: boolean;
  organizationConfig?: OrganizationConfig | null;
  savedRejectionMessage?: string | null;
  userEmail?: string;
  websiteUrl?: string;
};

const defaultRejectionMessages = {
  standard: ({ email, websiteUrl }: { email: string; websiteUrl: string }) =>
    `I'm sorry, but based on your response, it appears you may not meet some essential requirements for this role. I would suggest you visit ${websiteUrl} to discover other opportunities that may better align with your experience and skills. If you have any questions, email ${email}.`,
  engagement: () =>
    "I'm sorry but based on our conversation, I'm afraid you don't quite meet our requirements at the moment. Thank you very much for your time, and have a lovely day."
};

export const getDefaultRejectionMessage = ({
  isEngagementOutreach,
  organizationConfig,
  savedRejectionMessage,
  userEmail,
  websiteUrl
}: GetDefaultRejectionMessageParams): string => {
  // Get saved campaign message, use if available
  if (savedRejectionMessage) {
    return savedRejectionMessage;
  }

  // Get organizationConfig message, use if available
  if (organizationConfig?.rejectionMessage) {
    return organizationConfig.rejectionMessage;
  }

  // Otherwise use default message
  if (userEmail && websiteUrl) {
    return isEngagementOutreach
      ? defaultRejectionMessages.engagement()
      : defaultRejectionMessages.standard({ email: userEmail, websiteUrl });
  }

  return '';
};
